/**
 * SGKC028A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Sgkc028aReqSlideadjustmentunitpriceCancelInfoDto {

    /**
     * スライド調整単価コード
     */
    slideadjustmentunitpriceCode?: string;
    /**
     * 適用開始年月
     */
    applyStartyearmonth?: string;
    /**
     * 適用開始日付
     */
    applyStartDate?: string;
    /**
     * 更新通番号
     */
    updateSrno?: string;
}

